export default __webpack_public_path__ + "static/media/wall1.81ceddcf.jpg";